import * as React from "react";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./SlideDeleteValidator.scss";
import "../../css/Popup.scss";

export default function SlideDeleteValidator(props) {
 

  return (
    <div className="deletePromptParent">
      <Dialog
        open={props.prompt}
        onClose={()=>{}}
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="deletePrompt"
        sx={{
          backdropFilter: "blur(2.4px)",
          //other styles here
        }}
      >
        <DialogContent onClick={(e) => e.stopPropagation()}>
          <DialogContentText
            id="alert-dialog-description"
            className="discription"
          >
            <div className="popup-head">
              Are you sure you want to
              <span style={{ color: "red" }}>
                {` delete slide ${props.nthSlide} `}
              </span>
              ?
            </div>
            {false && !props.child && !props.isPdf && (
              <div
                className="popup-message"
                style={{
                  color: "red",
                  fontWeight: "normal",
                  fontSize: "12px",
                  paddingTop: "8px",
                }}
              >
                Note: All related subslides will be deleted too
              </div>
            )}
          </DialogContentText>
        </DialogContent>
        <div className="popupFooter" onClick={(e) => e.stopPropagation()}>
          {/* <div className="popupFooterSeparator"></div> */}
          <Button
            className="btn popupFooterGrayedButton"
            type="button"
            onClick={() => props.setPrompt(false)}
          >
            Cancel
          </Button>
          <Button
            className="btn popupFooterActiveButton"
            type="button"
            onClick={props.deleteSlide}
          >
            Delete
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
